import { Text, View, StyleSheet } from 'react-native';
import { COLORS } from '../constants';
import { useGlobalContext } from '../context/GlobalContext';

function formatTime (time: number) {
  const newtime = Math.floor(time / 1000);
  if (newtime === 0) {
    return '00:00';
  }
  if (newtime < 60) {
    return `00:${(newtime + '').padStart(2, '0')}`;
  } else {
    return (Math.floor(newtime / 60) + '').padStart(2, '0') + ':' + ((newtime % 60) + '').padStart(2, '0');
  }
}

function Timer () {
  const { currentTimer, totalTimer } = useGlobalContext()

  const getWidth = () => {
    return `${currentTimer * 100 / totalTimer}%`;
  }

  return (
    <View style={styles.container}>
      <View style={[styles.timer, { width: getWidth() }]}>
        <View style={styles.timerPoint}></View>
      </View>
      <Text style={styles.time}>{formatTime(currentTimer)} / {formatTime(totalTimer)}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  timer: {
    position: 'relative',
    borderTopColor: COLORS.warning,
    borderTopWidth: 3,
    width: 0
  },
  timerPoint: {
    position: 'absolute',
    width: 12,
    height: 12,
    backgroundColor: COLORS.warning,
    right: 0,
    top: -7,
    borderRadius: 50
  },
  time: {
    position: 'absolute',
    fontFamily: 'Poppins',
    color: COLORS.text,
    fontSize: 11,
    paddingLeft: 5,
    paddingTop: 5,
  },
});

export default Timer;
